import * as React from "react";
import styled from "styled-components";
import StringUtils from "util/StringUtils";
import useSelectedEntities from "./hooks/useSelectedEntities";
const Container = styled.div`
  display: flex;
  align-items: center;
`;
const SelectedEntitiesAmount = styled.div`
  margin-left: 5px;
`;
const BulkActionsRow = ({ bulkActions, className = void 0 }) => {
  const { selectedEntities } = useSelectedEntities();
  return /* @__PURE__ */ React.createElement(Container, { className }, bulkActions, !!selectedEntities.length && /* @__PURE__ */ React.createElement(SelectedEntitiesAmount, null, selectedEntities.length, " ", StringUtils.pluralize(selectedEntities.length, "item", "items"), " selected"));
};
export default BulkActionsRow;
